import { Routes } from '@angular/router';
import { AUTH_REDIRECT_ROUTE } from '@shared/constants/fields.constants';
import { ngxPermissionsGuard } from 'ngx-permissions';

export const settingRoutes: Routes = [
   {
      path: 'configurations',
      loadComponent: () => import('./configurations/configurations').then(c => c.Configurations),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_SETTINGS_SYSTEM_CONFIG_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'regions',
      loadComponent: () => import('./regions/regions').then(c => c.Regions),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_SETTINGS_REGION_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'taxes',
      loadComponent: () => import('./taxes/taxes.component').then(c => c.TaxesComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_SETTINGS_TAXES_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'currencies',
      loadComponent: () => import('./currencies/currencies.component').then(c => c.CurrenciesComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_SETTINGS_CURRENCIES_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'countries',
      loadComponent: () => import('./countries/countries').then(c => c.CountriesComponent)
   },
   {
      path: 'product-categories',
      loadComponent: () => import('./product-categories/product-categories').then(c => c.ProductCategoriesComponent)
   },
   {
      path: 'unit-of-measures',
      loadComponent: () => import('./unit-of-measures/unit-of-measures').then(c => c.UnitOfMeasuresComponent)
   },
   {
      path: 'attachment-types',
      loadComponent: () => import('./attachment-types/attachment-types.component').then(c => c.AttachmentTypesComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_ATTACHMENT_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'registration-attachment-types',
      loadComponent: () => import('./registration-attachment-types/registration-attachment-types.component').then(c => c.RegistrationAttachmentTypesComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_ATTACHMENT_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'public-attachments',
      loadComponent: () => import('./public-attachments/public-attachments.component').then(c => c.PublicAttachmentsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_PUBLIC_ATTACHMENT_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'faqs',
      loadComponent: () => import('./faqs/faqs.component').then(c => c.FaqsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_SETTINGS_FAQ_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'approval-configurations',
      loadComponent: () => import('./approval-configurations/approval-configurations.component').then(c => c.ApprovalConfigurationsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_WF_APPROVAL_CONFIGURATION_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'bank-details',
      loadComponent: () => import('./bank-details/bank-details.component').then(c => c.BankDetailsComponent)
   },
   {
      path: 'fee-configurations',
      loadComponent: () => import('./fee-configurations/fee-configurations.component').then(c => c.FeeConfigurationsComponent)
   },
   {
      path: 'enforcement-reasons',
      loadComponent: () => import('./enforcement-reasons/enforcement-reasons.component').then(c => c.EnforcementReasonsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_REGISTRATION_ENFORCEMENT_REASON_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'enforcement-rules-config',
      loadComponent: () => import('./enforcement-rules-config/enforcement-rules-config.component').then(c => c.EnforcementRulesConfigComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_ENFORCEMENT_RULES_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'enforcement-rules-config/new',
      loadComponent: () => import('./enforcement-rule-form/enforcement-rule-form.component').then(c => c.EnforcementRuleFormComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_ENFORCEMENT_RULES_ADD'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'enforcement-rules-config/:uuid/edit',
      loadComponent: () => import('./enforcement-rule-form/enforcement-rule-form.component').then(c => c.EnforcementRuleFormComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_ENFORCEMENT_RULES_EDIT'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'enforcement-rules-config/:uuid',
      loadComponent: () => import('./enforcement-rule-details/enforcement-rule-details.component').then(c => c.EnforcementRuleDetailsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_ENFORCEMENT_RULES_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'license-types',
      loadComponent: () => import('./license-types/license-types.component').then(c => c.LicenseTypesComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_SETTINGS_LICENSE_TYPES_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'compliance-reminders',
      loadComponent: () => import('./compliance-notifications/compliance-notifications.component').then(c => c.ComplianceNotificationsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_SETTINGS_LICENSE_TYPES_COMPLIANCE_REMINDERS_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'financial-years',
      loadComponent: () => import('./financial-years/financial-years.component').then(c => c.FinancialYearsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_SETTINGS_FINANCIAL_YEARS_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'calendar-years',
      loadComponent: () => import('./calendar-years/calendar-years.component').then(c => c.CalendarYearsComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_SETTINGS_CALENDAR_YEARS_VIEW'],
            redirectTo: AUTH_REDIRECT_ROUTE
         }
      }
   },
   {
      path: 'omc-document-configs/custom-templates',
      loadComponent: () =>
         import('@modules/omc-document-configs/omc-custom-templates/omc-custom-templates.component').then(
            c => c.OmcCustomTemplatesComponent,
         ),
   },
   {
      path: 'omc-document-configs/custom-templates/new',
      loadComponent: () =>
         import('@modules/omc-document-configs/custom-template-form/custom-template-form.component').then(
            c => c.CustomTemplateFormComponent,
         ),
   },
   {
      path: 'omc-document-configs/custom-templates/:uuid/edit',
      loadComponent: () =>
         import('@modules/omc-document-configs/custom-template-form/custom-template-form.component').then(
            c => c.CustomTemplateFormComponent,
         ),
   },
   {
      path: 'agent-types',
      loadComponent: () =>
         import('./agent-types/agent-types.component').then(c => c.AgentTypesComponent),
      canActivate: [ngxPermissionsGuard],
      data: {
         permissions: {
            only: ['ROLE_VIEW_AGENT_TYPE'],
            redirectTo: AUTH_REDIRECT_ROUTE,
         },
      },
   },
];
